/**
 * inCust terminal API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export interface CouponCode {
  /**
   * Coupon code
   */
  code: string | null;
  /**
   * Error string (optional, readonly)
   */
  error?: string | null;
  /**
   * Is code of coupon valid (optional, readonly)
   */
  valid?: boolean | null;
}
